import React, { useContext } from "react";
import { faPowerOff } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AuthContext from "../context/auth/authContext";

const Header = props => {
  const userSession = localStorage.getItem("user") === null ? null : JSON.parse(localStorage.getItem("user"));
  const authContext = useContext(AuthContext);
  const { logout } = authContext;

  const onLogout = () => {
    logout();
  };

  return (
    <div>
      <div className="container-fluid">
        <div
          className="row"
          style={{ background: "linear-gradient(to right, #9c343f, #551c25)" }}
        >

          {/* <div className="col-sd-1 toggle-menu">
            <i className="fa fa-bars" ></i>
          </div> */}
          <div className="col-md-8 text-left">
            <h1 className="text-white mt-2 mb-2" style = {{paddingLeft: "24px", fontFamily: "'FontAwesome'"}} >
              WE | Pro
          </h1>
          </div>
          <div className="col-md-3 text-right m-auto">
            <span className="text-white">
              {userSession && `${userSession[0].Title} ${userSession[0].Name} ${userSession[0].Surname}`}
            </span>
          </div>
          <div className="col-md-1 text-right m-auto">
            <button className="btn btn-danger" onClick={onLogout}>
              <FontAwesomeIcon icon={faPowerOff} />
            </button>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
};

export default Header;
